<template>

    <b-card>

        <b-btn class="pull-right" variant="primary" :href="`/${controller}/${knowledgePath}/create`" v-if=" !isCarrierManager ">Add Item</b-btn>

        <h3>FAQs</h3>
        <div class="table-responsive">

            <b-table hover
                sort-by="title"
                :items="faq"
                :fields="fields"
                show-empty
            >
                <template v-slot:cell(title)="row">
                    {{ truncate(row.item.title, 50) }}
                </template>
                <template v-slot:cell(for_carriers)="row">
                    <p v-if=" !matchCarriers( row.item.for_carriers ) " style="color:red">None!</p>
                    <p v-else>{{ matchCarriers( row.item.for_carriers ) }}</p>
                </template>
                <template v-slot:cell(for_roles)="row">
                    <p v-if=" !matchRoles( row.item.for_roles ) " style="color:red">None!</p>
                    <p v-else>{{ matchRoles( row.item.for_roles ) }}</p>
                </template>
                <template v-slot:cell(actions)="row">
                    <b-btn size="sm" :href="`/${controller}/${knowledgePath}/${row.item.id}`" variant="info" v-b-tooltip.hover title="Edit">
                        <i class="fa fa-edit"></i>
                    </b-btn>
                    <b-btn size="sm" @click="destroy(row.item)" variant="danger" v-b-tooltip.hover title="Delete">
                        <i class="fa fa-times"></i>
                    </b-btn>
                </template>
            </b-table>
        </div>

        <h3>Tutorials</h3>
        <div class="table-responsive">
            <b-table hover
                     sort-by="title"
                     :items="tutorials"
                     :fields="fields"
                     show-empty
            >
                <template v-slot:cell(title)="row">
                    {{ truncate(row.item.title, 35) }}
                </template>
                <template v-slot:cell(for_carriers)="row">
                    <p v-if=" !matchCarriers( row.item.for_carriers ) " style="color:red">None!</p>
                    <p v-else>{{ matchCarriers( row.item.for_carriers ) }}</p>
                </template>
                <template v-slot:cell(for_roles)="row">
                    <p v-if=" !matchRoles( row.item.for_roles ) " style="color:red">None!</p>
                    <p v-else>{{ matchRoles( row.item.for_roles ) }}</p>
                </template>
                <template v-slot:cell(actions)="row">
                    <b-btn size="sm" :href="`/${controller}/${knowledgePath}/${row.item.id}`" variant="info" v-b-tooltip.hover title="Edit">
                        <i class="fa fa-edit"></i>
                    </b-btn>
                    <b-btn size="sm" @click="destroy(row.item)" variant="danger" v-b-tooltip.hover title="Delete">
                        <i class="fa fa-times"></i>
                    </b-btn>
                </template>
            </b-table>
        </div>

        <h3>Resources</h3>
        <div class="table-responsive">
            <b-table hover
                     sort-by="title"
                     :items="resources"
                     :fields="fields"
                     show-empty
            >
                <template v-slot:cell(title)="row">
                    {{ truncate(row.item.title, 35) }}
                </template>
                <template v-slot:cell(updated_at)="row">
                  <utc-time :time="row.item.updated_at" :role="this.role" />
                </template>
                <template v-slot:cell(for_carriers)="row">
                    <p v-if=" !matchCarriers( row.item.for_carriers ) " style="color:red">None!</p>
                    <p v-else>{{ matchCarriers( row.item.for_carriers ) }}</p>
                </template>
                <template v-slot:cell(for_roles)="row">
                    <p v-if=" !matchRoles( row.item.for_roles ) " style="color:red">None!</p>
                    <p v-else>{{ matchRoles( row.item.for_roles ) }}</p>
                </template>
                <template v-slot:cell(actions)="row">
                    <b-btn size="sm" :href="`/${controller}/${knowledgePath}/${row.item.id}`" variant="info" v-b-tooltip.hover title="Edit">
                        <i class="fa fa-edit"></i>
                    </b-btn>
                    <b-btn size="sm" @click="destroy(row.item)" variant="danger" v-b-tooltip.hover title="Delete">
                        <i class="fa fa-times"></i>
                    </b-btn>
                </template>
            </b-table>
        </div>
    </b-card>
</template>

<script>

    import FormatsDates from '../../mixins/FormatsDates';
    import UsesRole from "../../mixins/UsesRole";

    export default {

        mixins: [ FormatsDates, UsesRole ],

        props: [ 'knowledgeBase', 'carriers' ],

        data() {
            return {
                items: [],
                fields: [
                    {
                        key: 'title',
                        label: 'Title',
                    },
                    {
                        key: 'updated_at',
                        label: 'Date Modified',
                    },
                    {
                        key : 'for_roles',
                        label: 'For Roles',
                    },
                    {
                        key : 'for_carriers',
                        label: 'For Carriers',
                        class: 'knowledge-max-width-control'
                    },
                    {
                        key: 'actions',
                        label: 'Actions',
                    }
                ],
            };
        },

        computed: {
            faq() {
                return this.items.filter(item => item.type == 'faq');
            },

            tutorials() {
                return this.items.filter(item => item.type == 'tutorial');
            },

            resources() {
                return this.items.filter(item => item.type == 'resource');
            },

        },

        methods: {

            matchCarriers( item ){

                if( item.length == 0 ) return null;
                const items = item.map( i => {

                    let carrier = this.carriers.find( c => c.id.toString() == i );
                    return carrier ? carrier.name : null;
                }).join( ', ' );

                return items;
            },
            matchRoles( item ){

                if( item.length == 0 ) return null;
                return item.join( ',  ' );
            },
            hasRoles( row ){

                return ( count( row.item.for_roles ) == 0 || empty( row.item.for_roles ) );
            },
            hasCarriers( row ){

                return ( count( row.item.for_carriers ) == 0 || empty( row.item.for_carriers ) );
            },
            truncate(string, chars = 50) {
                if (string.length > chars) {
                    return string.substr(0, chars) + '...';
                }

                return string;
            },

            destroy(item) {
                let form = new Form();
                if (confirm('Are you sure you want to delete the item "' + item.title + '" ?')) {
                    form.submit('delete', `/${this.controller}/${this.knowledgePath}/${item.id}`)
                        .then( ({ data }) => {
                            this.items = data.data;
                        })
                        .catch(e => {

                        })
                }
            },
        },

        mounted() {
            this.items = this.knowledgeBase;
        },
    }
</script>

<style>

    .knowledge-max-width-control{

        max-width: 235px;
    }
</style>
